import React from 'react';

export class Base extends React.Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        const p = this.props;
        return (
            <input 
                className       = 'marketkit-checkbox-wrapper-base'
                onChange        = { (e) => p.onChange(e) }
                type            = "checkbox"
                defaultChecked  = { p.isChecked }
            />            
        )
    }
}

export default Base;